import { render, staticRenderFns } from "./EditCommunitySpaceOpenTime.vue?vue&type=template&id=bedb1ae2&scoped=true"
import script from "./EditCommunitySpaceOpenTime.vue?vue&type=script&lang=js"
export * from "./EditCommunitySpaceOpenTime.vue?vue&type=script&lang=js"
import style0 from "./EditCommunitySpaceOpenTime.vue?vue&type=style&index=0&id=bedb1ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedb1ae2",
  null
  
)

export default component.exports